<template>
    <b-card shadow type="secondary">
        <b-row>
            <b-col l="8">
                <h4>Category</h4>  
            </b-col>
            <b-col l="4">
                <b-button class="float-right" variant="secondary"  @click="cancel()"><i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back</b-button>        
            </b-col>
        </b-row>
        <b-card-body>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name*"
                    label-for="input-name"
                >
                    <!-- disable editability if the user can view but not update -->
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        v-if="hasPermissionUpdate"
                        placeholder="Enter Name"
                        trim
                        :disabled="canView"
                    ></b-form-input>
                </b-form-group>
                <b-button-group size="sm">
                <b-button
                    variant="secondary"
                    :disabled="loading ? true : false"
                    @click="cancel()"
                    >{{ cancelLabel }}</b-button
                >
                <!-- render the submit button only if the user can update or create -->
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="loading ? true : false"
                    v-if="hasPermissionCreate || hasPermissionUpdate"
                    >{{ submitLabel }}</b-button
                >
                <b-button
                    @click="deleteItem()"
                    class="mr-2"
                    variant="warning"
                    v-if="hasPermissionDelete && this.model.id"
                >
                    Delete
                </b-button>
                </b-button-group>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orderCategories-ViewItem',
    mixins: [permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id &&
                this.user_permissions.includes('create.order.categories')
                ? true
                : false
        },
        /**
         * True if the user has permission to view but not update an order category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return this.model.id &&
                !this.user_permissions.includes('update.order.categories') &&
                this.user_permissions.includes('view.order.categories')
                ? true
                : false
        },
        /**
         * True if the user has permission to update an order category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id &&
                this.user_permissions.includes('update.order.categories')
                ? true
                : false
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const action=model.id ? 'update' : 'create'
            const path = `orderCategory/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit('success', action, this.model.name)
                        })
                        .catch(error => {
                            this.$emit('error',error, this.model.name)
                          
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables    
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'orderCategory/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Activity Category?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Activity Category!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('deleted',model.name)
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
